import {
  Box,
  Flex,
  Heading,
  Stack,
  Tag,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import {
  getYearFromCompaniesHouseDate,
  tradingNameParser,
} from "src/lib/utils";
import ContactDetails from "./ContactDetails";
import InstallerServices from "./InstallerServices";

const InstallerCard = (installer) => {
  const {
    id,
    name,
    accreditation_status,
    guessed_companies_house_founded_date,
    installer_notes,
    voltwise_id,
    email,
  } = installer;

  const yearFounded = guessed_companies_house_founded_date
    ? getYearFromCompaniesHouseDate(guessed_companies_house_founded_date)
    : "Year founded unknown";

  const renderWarningTag = () => {
    if (accreditation_status === false) {
      return (
        <Tooltip
          label={`When we last checked, ${name} did not appear on the MCS accredited list.`}
        >
          <Tag bg={"red.500"} color={"white"}>
            Warning: MCS Certificate May Have Expired
          </Tag>
        </Tooltip>
      );
    }
    return null;
  };

  return (
    <Box bg={"white"} key={id} borderWidth="1px" p={8} borderRadius={4} mb={8}>
      <Box>
        {renderWarningTag()}
        <Stack
          direction={["column", "row"]}
          justify={"space-between"}
          alignItems={"center"}
          mt={3}
        >
          <Heading as={"h1"} mt={0} color="#0B3948" size="lg" mb={0}>
            {tradingNameParser(name)}
          </Heading>
          <ContactDetails {...installer} />
        </Stack>
        <Text color={"gray.400"} fontWeight={"light"} mb={6}>
          {yearFounded}
        </Text>

        <Text>{installer_notes}</Text>
        <Flex direction={["column", "row"]}>
          <InstallerServices {...installer} variant />
        </Flex>
      </Box>

      <Text mt={"50px"} color={"gray.400"}>
        Do you work for {name}?{" "}
        <a
          href={`/claim?voltwise_id=${voltwise_id}&name=${name}&email=${email}`}
        >
          Click to claim
        </a>{" "}
        this page
      </Text>
    </Box>
  );
};

export default InstallerCard;
